export const breadcrumbTypes = {
    PARENT_PAGE_REFERENCE: 'Parent Page Reference',
    CATEGORY_MANUAL: 'Category Manual',
    CATEGORY: 'Category',
    CUSTOM: 'Custom'
}

export const generateBreadcrumbLinkContent = ({title, pageData, isClickable = true}) => ({
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-fa754bedd202459cbb5db052daa4039f',
    component: {
        name: 'BreadcrumbLink',
        options: {
            isClickable,
            pageReference: pageData,
            label: title || pageData.title
        }
    }
})

export const homePageData = {
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'BreadcrumbLink',
        options: {
            isClickable: true,
            pageReference: {
                model: 'page',
                value: {data: {url: '/', title: 'Home'}}
            },
            label: 'Home'
        }
    }
}

export const getBreadcrumbLinkInputs = (isCustom = false) => [
    {
        name: 'isClickable',
        type: 'boolean',
        defaultValue: true,
        helperText: 'Set to false if you want the crumb to just be a label.'
    },
    {
        name: 'pageReference',
        type: 'reference',
        model: 'page',
        required: true,
        showIf: `options.get('isClickable') === true`
    },
    {
        name: 'label',
        type: 'string',
        helperText: 'Will override page title if pageReference is present.',
        defaultValue: isCustom ? 'Default Custom Label' : undefined
    }
]

export const getCategoryLinkInputs = (isCustom = false) => [
    {
        name: 'isClickable',
        type: 'boolean',
        defaultValue: true,
        helperText: 'Set to false if you want the crumb to just be a label.'
    },
    {
        name: 'category',
        type: 'SFCommerceCategory',
        options: {
            includeRefs: true
        },
        required: true,
        helperText:
            'The category to link to. This will be used to generate the URL for the breadcrumb link.'
    },
    {
        name: 'label',
        type: 'string',
        helperText: 'Will override page title if pageReference is present.',
        defaultValue: isCustom ? 'Default Custom Label' : undefined
    }
]

export const getStandardBreadcrumbInputs = () => [
    {
        name: 'separator',
        type: 'string',
        defaultValue: '>',
        friendlyName: 'Breadcrumb Separator'
    },
    {
        name: 'includeHome',
        type: 'boolean',
        defaultValue: true,
        helperText: 'Include Home as the first breadcrumb'
    },
    {
        name: 'type',
        type: 'string',
        required: true,
        enum: Object.values(breadcrumbTypes),
        defaultValue: breadcrumbTypes.PARENT_PAGE_REFERENCE,
        onChange: (options) => {
            if (options.get('type') === breadcrumbTypes.PARENT_PAGE_REFERENCE) {
                options.set('customCrumbs', [])
            }
        }
    },
    {
        name: 'customCrumbs',
        type: 'list',
        subFields: getBreadcrumbLinkInputs(true),
        showIf: `options.get('type') === '${breadcrumbTypes.CUSTOM}'`
    },
    {
        name: 'categoryCrumbs',
        type: 'list',
        subFields: getCategoryLinkInputs(true),
        showIf: `options.get('type') === '${breadcrumbTypes.CATEGORY_MANUAL}'`,
        helperText:
            'Optional: Manually configure category breadcrumbs. If left empty on a PLP page, breadcrumbs will be auto-generated from the category hierarchy.'
    }
]
